export default __webpack_public_path__ + "static/media/Trust.187e90f9.jpeg";